export default {
  pagination: {},
  flowProcesses: [],
  processData: {},
  selectedProcess: {},
  flowsFilter: [],
  links: {},
};
